module.exports = __webpack_public_path__ + "static/img/faPath3.ff9ab048.gif";